import { DEFAULT_LOCALE, Locale } from '../constants/locale';
import { Country } from '../constants/country';
import type { RequestInput } from '../types';

export const getLocale = () =>
    Object.values(Locale).includes(process.env.NEXT_PUBLIC_LOCALE as Locale)
        ? (process.env.NEXT_PUBLIC_LOCALE as Locale)
        : DEFAULT_LOCALE;

export const getCountry = () => {
    const locale = getLocale();
    const country = {
        [Locale['en-US']]: Country.US,
        [Locale['en-CA']]: Country.CA,
    };

    return country[locale];
};

export const getCountryLocale = (country: Country): Locale => {
    const countryLocale = {
        [Country.US]: Locale['en-US'],
        [Country.CA]: Locale['en-CA'],
    };

    return countryLocale[country];
};

export function isLocaleCA() {
    return getLocale() === Locale['en-CA'];
}

export const urlWithLocale = (input: RequestInput): RequestInput => {
    const isString = typeof input === 'string';
    const locale = getLocale();

    if (input instanceof URL) {
        input.searchParams.set('locale', locale);

        return input;
    }

    const url = new URL(isString ? input : input.toString());

    url.searchParams.set('locale', locale);

    return isString ? url.toString() : url;
};
